import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedUserRegisterService {

  constructor() { }
  private userDetailsSubject = new Subject<any>();
    public userDetails$ = this.userDetailsSubject.asObservable();
    setUserInformation(data: any): void {
      this.userDetailsSubject.next(data); // Emit new data to subscribers
    }
}
